import { useEffect, useRef } from 'react';
import { FILTERS_PROVIDER_UI_REFS } from '../consts';
import useContextActions from '../useContextActions';

const useUiRefByKey = (Context, uiRefKey) => {
  const contextActions = useContextActions({ Context });
  const ref = useRef();

  const isUiRefKeyExists = Object.values(FILTERS_PROVIDER_UI_REFS).includes(
    uiRefKey
  );

  useEffect(() => {
    if (!isUiRefKeyExists)
      throw new Error(
        'uiRefKey is not exists. please add it to FILTERS_PROVIDER_UI_REFS const'
      );

    contextActions.setUiRef(uiRefKey, ref);
  }, [ref.current]);

  return ref;
};

export default useUiRefByKey;
